import {
  buildFormData,
  overParseJson,
  checkAttendantAndFetch,
} from '../utils/requestUtils';

const BASE_URL = 'https://afiliados.uol.com.br';
const SAVE_REPORT_URL = `${BASE_URL}/api/saveReport.html`;
const UPDATE_REPORT_ULR = `${BASE_URL}/api/updateSavedReport.html`;
const DELETE_REPORT_ULR = `${BASE_URL}/api/deleteSavedReport.html`;
const SAVED_REPORTS_API_URL = `${BASE_URL}/api/listReports.html`;
const HTTP_ERROR = 'HTTP_ERROR';
const DEFAULT_FETCH_OPTIONS = {
  credentials: 'same-origin',
};

class savedFiltersApi {
  static buildSaveReportPayload(reportOptions, ReportName) {
    return {
      ajax: true,
      'savedReportRequest.desUserSupplierReport': ReportName,
      types: reportOptions.products,
      period: reportOptions.period,
      sites: reportOptions.sites,
      identifiers: reportOptions.identifiers,
      'savedReportRequest.startDate': reportOptions.startDate,
      'savedReportRequest.endDate': reportOptions.endDate,
      'savedReportRequest.orderBy': 'datevent',
      'savedReportRequest.orderType': 'ASC',
    };
  }

  static buildUpdateReportPayload(reportOptions, ReportId) {
    return {
      ajax: true,
      'savedReportRequest.idtUserSupplierReport': ReportId,
      'savedReportRequest.desUserSupplierReport': reportOptions.name,
      types: reportOptions.products,
      period: reportOptions.period,
      sites: reportOptions.sites,
      identifiers: reportOptions.identifiers,
      'savedReportRequest.startDate': reportOptions.startDate,
      'savedReportRequest.endDate': reportOptions.endDate,
      'savedReportRequest.orderBy': 'datevent',
      'savedReportRequest.orderType': 'ASC',
    };
  }

  static buildDeleteReportPayload(reportIds) {
    return {
      ajax: true,
      reports: reportIds,
    };
  }

  static async updateFilter(reportOptions, reportId) {
    try {
      const payload = buildFormData(this.buildUpdateReportPayload(reportOptions, reportId));
      const fetchResponse = await checkAttendantAndFetch(UPDATE_REPORT_ULR, {
        method: 'POST',
        credentials: 'same-origin',
        body: payload,
      });

      const text = await fetchResponse.text();
      const data = overParseJson(text);

      if (fetchResponse.status !== 200) {
        const error = new Error(data.error);
        error.code = HTTP_ERROR;
        error.status = fetchResponse.status;
        throw error;
      }

      return data;
    } catch (error) {
      throw error;
    }
  }

  static async deleteFilter(reportIds) {
    try {
      const payload = buildFormData(this.buildDeleteReportPayload(reportIds));
      const fetchResponse = await checkAttendantAndFetch(DELETE_REPORT_ULR, {
        method: 'POST',
        credentials: 'same-origin',
        body: payload,
      });

      const text = await fetchResponse.text();
      const data = overParseJson(text);

      if (fetchResponse.status !== 200) {
        const error = new Error(data.error);
        error.code = HTTP_ERROR;
        error.status = fetchResponse.status;
        throw error;
      }

      return data;
    } catch (error) {
      throw error;
    }
  }

  static async saveFilter(reportOptions, reportName) {
    try {
      const payload = buildFormData(this.buildSaveReportPayload(reportOptions, reportName));
      const fetchResponse = await checkAttendantAndFetch(SAVE_REPORT_URL, {
        method: 'POST',
        credentials: 'same-origin',
        body: payload,
      });

      const text = await fetchResponse.text();
      const data = overParseJson(text);

      if (fetchResponse.status !== 200) {
        const error = new Error(data.error);
        error.code = HTTP_ERROR;
        error.status = fetchResponse.status;
        throw error;
      }

      return data;
    } catch (error) {
      throw error;
    }
  }

  static async getSavedReports() {
    try {
      const fetchResponse = await checkAttendantAndFetch(SAVED_REPORTS_API_URL, {
        method: 'GET',
        ...DEFAULT_FETCH_OPTIONS,
      });
      const text = await fetchResponse.text();
      const json = overParseJson(text);
      const data = json;

      if (fetchResponse.status !== 200) {
        const error = new Error(data.error);
        error.code = HTTP_ERROR;
        error.status = fetchResponse.status;
        throw error;
      }

      return data;
    } catch (error) {
      throw error;
    }
  }
}

export default savedFiltersApi;
